import React from 'react';
import { connect } from 'react-redux';
import Ax from '../../../components/hoc/Ax';
import Loader from '../../../components/ui/Loader/Loader';
import HttpAPICall from "../../../services/HttpAPICall";
import TapSelect from '../../../components/ui/TapSelect';
import { DisplayListPagination, PeriodSelectionWithCustom } from '../../../components/TapUi';
import moment from "moment";
import { INVENTORY_API_BASE_URL_2 } from '../../../services/TapApiUrls';
import AppBaseComponent from '../../../components/AppBaseComponent';

class TransactionLedgerContent extends AppBaseComponent {

    constructor(props) {
        super(props);

        this.reportFilterFormInitialState = {
            warehouse_id: '',
            item_id: '',
            transaction_type: [],
            date_range: '',
            date_range_start: '',
            date_range_end: '',
        };

        this.reportFilterFormLabel = {
            warehouse_id: 'Search Warehouse : ',
            item_id: 'Search Item : ',
            date_range: 'Date Range : ',
            transaction_type: 'Search Transaction Type : ',
        };

        this.state = {
            listing_loading: true,
            listingData: [],
            listingMeta: null,
            summaryData: null,
            summary_loading: true,
            all_periods: [],
            allStockTransactions: [],
            formDataLoaded: false,
            itemData: this.props.itemData || null,
            warehouseDetail: this.props.warehouseDetail || null,
            transactionId: '',
            transanctionType: '',
            reportFilterForm: { ...this.reportFilterFormInitialState },
            submittedReportFilterForm: { ...this.reportFilterFormInitialState },
            showTransactionType: this.props.showTransactionType || false
        };

    }

    componentDidMount() {
        const { itemData, warehouseDetail, showTransactionType } = this.props;
        const { all_periods_from_store } = this.props;

        if (itemData && warehouseDetail) {
            let url = INVENTORY_API_BASE_URL_2 + '/report/item-stock-ledger/form_data';
            let all_periods = [...all_periods_from_store, { key: 'custom', display: 'Custom Date Range' }];

            HttpAPICall.withAthorization('GET', url, this.props.access_token, null, null, (response) => {
                this.setState({
                    all_periods: all_periods,
                    itemData: itemData,
                    warehouseDetail: warehouseDetail,
                    showTransactionType: showTransactionType,
                    allStockTransactions: response.data && response.data.stock_transactions && response.data.stock_transactions.length > 0
                        ? response.data.stock_transactions.map((m) => { return { value: m.key, label: `${m.name}` } })
                        : [],
                }, () => {
                    let updateFilterForm = { date_range: showTransactionType ? "trailing_twelve_months" : "current_year" };

                    this.setState({
                        reportFilterForm: { ...this.state.reportFilterForm, ...updateFilterForm },
                    }, () => {
                        this.reportFilterFormSubmit(null);
                    });
                });
            }, (err) => {
                console.error("Error loading form data:", err);
            });
        }
    }

    reportFilterFormSubmit = (event = null, loading = false) => {
        event && event.preventDefault();
        if (loading == true) {
            this.setState({ listing_loading: true, summary_loading: true })
        }
        let serachFormKeys = Object.keys(this.state.reportFilterForm);
        let searchedElems = [];
        let itemSearchParams = {};
        serachFormKeys.map((key) => {
            let label = this.reportFilterFormLabel[key];
            let value = this.state.reportFilterForm[key];
            if (value && value.toString().length > 0) {
                itemSearchParams[key] = value;
                if (label) {
                    let show_val = value;
                    if (key == 'transaction_type') {
                        show_val = this.state.allStockTransactions.filter((s) => value.includes(s.value)).map(s => s.label).join(', ');
                    }
                    if (key == 'date_range') {
                        let start_range = moment(this.state.reportFilterForm.date_range_start).format('DD-MMM-YYYY');
                        let end_range = moment(this.state.reportFilterForm.date_range_end).format('DD-MMM-YYYY')
                        let display_custom = `Custom Date Range (${start_range} - ${end_range})`
                        show_val = this.state.all_periods.filter((s) => value.includes(s.key)).map(s => s.display_with_date ? s.display_with_date : display_custom);
                    }
                    searchedElems.push(label + `<b>${show_val}</b>`);
                }
            }
        });
        this.setState({
            submittedReportFilterForm: { ...this.state.reportFilterForm, warehouse_id: this.state.warehouseDetail.id, item_id: this.state.itemData.id },
        }, () => {
            this.loadListingTblData(1);
        });
    }

    loadListingTblData = (page = 1) => {
        this.setState({
            listingData: [],
            listingMeta: null,
            summaryData: null,
        });

        let transactionSummaryUrl = INVENTORY_API_BASE_URL_2 + '/report/item-stock-ledger/summary';
        let transactionListingUrl = INVENTORY_API_BASE_URL_2 + '/report/item-stock-ledger/list';
        let params = { page: page, ...this.state.submittedReportFilterForm };

        // Summary API
        HttpAPICall.withAthorization('GET', transactionSummaryUrl, this.props.access_token, params, {}, (response) => {
            this.setState({ summaryData: response.data });
        }).then(() => {
            this.setState({ summary_loading: false });
        });

        // Listing API
        HttpAPICall.withAthorization('GET', transactionListingUrl, this.props.access_token, params, {}, (response) => {
            let respData = response.data;
            this.setState({
                listingData: respData.data || [],
                listingMeta: {
                    from: respData.from || 1,
                    to: respData.to || 0,
                    total: respData.total || 0,
                    last_page: respData.last_page || 1,
                    per_page: respData.per_page || 10,
                    current_page: respData.current_page || 1
                }
            });
        }).then(() => {
            this.setState({ listing_loading: false });
        });
    }

    loadListingOnPageClick = (page = 1) => {
        this.setState({ listing_loading: true });

        let transactionListingUrl = INVENTORY_API_BASE_URL_2 + '/report/item-stock-ledger/list';
        let params = { page: page, ...this.state.submittedReportFilterForm };

        HttpAPICall.withAthorization('GET', transactionListingUrl, this.props.access_token, params, {}, (response) => {
            let respData = response.data;
            this.setState({
                listingData: respData.data || [],
                listingMeta: {
                    from: respData.from || 1,
                    to: respData.to || 0,
                    total: respData.total || 0,
                    last_page: respData.last_page || 1,
                    per_page: respData.per_page || 10,
                    current_page: respData.current_page || 1
                }
            });
        }).then(() => {
            this.setState({ listing_loading: false });
        });
    }

    viewTransactionModalInit = (transaction_type, transaction_id) => {
        // This will be handled by parent component via props
        if (this.props.onViewTransaction) {
            this.props.onViewTransaction(transaction_type, transaction_id);
        }
    }

    render() {
        const { itemData, warehouseDetail } = this.props;

        return (
            <div>
                {this.state.summary_loading ? (
                    <Loader />
                ) : (
                    <div className='p-1 bg-light border-bottom'>
                        <div className='row align-items-center'>
                            <div className='col-sm-7'>
                                <form onSubmit={(e) => this.reportFilterFormSubmit(e, true)}>
                                    <table className='table table-sm mb-0 table-borderless text-sm'>
                                        <tbody>
                                            <tr>
                                                <td style={{ width: "20%" }}>Item :</td>
                                                <th>
                                                    {this.state.summaryData && itemData ?
                                                        <span>{itemData.name} ({itemData.item_code})</span> : "-"}
                                                </th>
                                            </tr>
                                            <tr>
                                                <td>Warehouse :</td>
                                                <th>
                                                    {this.state.summaryData && warehouseDetail ?
                                                        <span>{warehouseDetail.name} ({warehouseDetail.code})</span> : "-"}
                                                </th>
                                            </tr>
                                            {!this.state.showTransactionType && (
                                                <tr>
                                                    <td>Transaction Type :</td>
                                                    <th>
                                                        <TapSelect
                                                            options={this.state.allStockTransactions}
                                                            changeEvent={(selectedOption) => this.tapSelectChange(selectedOption, 'reportFilterForm', 'transaction_type')}
                                                            value={this.state.allStockTransactions.filter(u => this.state.reportFilterForm?.transaction_type?.includes(u.value))}
                                                            isSearchable={true}
                                                            isMulti={true}
                                                            isClearable={true}
                                                            placeholder="Select Transaction Type"
                                                            containerHeight="30px"
                                                            fontSize="93%"
                                                            menuPlacement="bottom"
                                                        />
                                                    </th>
                                                </tr>
                                            )}
                                            <tr>
                                                <td>Period :</td>
                                                <th className='row'>
                                                    <div className='col-sm-10 pr0 mr0'>
                                                        <PeriodSelectionWithCustom
                                                            periods={this.state.all_periods}
                                                            value={this.state.reportFilterForm.date_range}
                                                            startDate={this.state.reportFilterForm.date_range_start}
                                                            endDate={this.state.reportFilterForm.date_range_end}
                                                            required={true}
                                                            onSelectPeriod={(period, startDate, endDate) => {
                                                                this.setState({
                                                                    reportFilterForm: {
                                                                        ...this.state.reportFilterForm,
                                                                        date_range: period,
                                                                        date_range_start: startDate || null,
                                                                        date_range_end: endDate || null
                                                                    }
                                                                });
                                                            }}
                                                            className="form-control-sm"
                                                            containerHeight="30px"
                                                            fontSize="93%"
                                                            menuPlacement="bottom"
                                                        />
                                                    </div>
                                                    <div className='col-sm-2 text-end'>
                                                        <button type="submit" className='btn btn-sm btn-primary'>
                                                            Go
                                                        </button>
                                                    </div>
                                                </th>
                                            </tr>
                                        </tbody>
                                    </table>
                                </form>
                            </div>
                            <div className='col-sm-5'>
                                <table className='table table-sm mb-0 table-borderless text-sm'>
                                    <tbody>
                                        <tr className='text-end'>
                                            <td style={{ width: "50%" }}>Opening Stock :</td>
                                            <th className='text-end'>{this.state.summaryData?.opening_stock ?? 0}</th>
                                        </tr>
                                        <tr className='text-end'>
                                            <td>Total Received :</td>
                                            <th className='text-end'>{this.state.summaryData?.total_received ?? 0}</th>
                                        </tr>
                                        <tr className='text-end'>
                                            <td>Total Issued :</td>
                                            <th className='text-end'>{this.state.summaryData?.total_issued ?? 0}</th>
                                        </tr>
                                        <tr className='text-end'>
                                            <td>Closing Stock :</td>
                                            <th className='text-end'>{this.state.summaryData?.closing_stock ?? 0}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                )}
                <div style={{ maxHeight: "300px", overflowY: "auto", marginTop: "8px", marginBottom: "8px" }}>
                    <table className="table table-bordered table-sm align-middle bg-white my-2 ">
                        <thead className="align-middle table-secondary">
                            <tr className='text-start'>
                                <th className="text-center" style={{ width: "5%" }}>S.No</th>
                                <th className='text-center' style={{ width: "10%" }}>Date of Transaction</th>
                                <th className='text-center' style={{ width: "10%" }}>Transaction Type</th>
                                <th className='text-center' style={{ width: "10%" }}>Transaction ID</th>
                                <th style={{ width: "30%" }}>Asset/Vendor/Workstation/Warehouse</th>
                                <th className='text-center' style={{ width: "9%" }}>Status</th>
                                <th className='text-end' style={{ width: "9%" }}>Received</th>
                                <th className='text-end' style={{ width: "9%" }}>Issued</th>
                            </tr>
                        </thead>
                        {this.state.listing_loading ? (
                            <tbody><tr><td colSpan="8"><Loader /></td></tr></tbody>
                        ) : (
                            <tbody>
                                {this.state.listingData.length > 0 ? (
                                    this.state.listingData.map((rowData, k) => (
                                        <tr key={rowData.transaction_id || k}>
                                            <td className='text-center'>{(this.state.listingMeta?.from || 1) + k}</td>
                                            <td className='text-center'>{rowData.transaction_date_display ?? "-"}</td>
                                            <td className='text-center'>{rowData.transaction_type_display ?? "-"}</td>
                                            <td className='text-center'>
                                                <button
                                                    className="btn text-decoration-none p-0"
                                                >
                                                    {rowData.transaction_id ?? "-"}
                                                </button>
                                            </td>
                                            <td>
                                                <small className='form-text'>
                                                    <b>
                                                        {rowData.transaction_type === "purchase" || rowData.transaction_type === 'purchase_return'
                                                            ? "Vendor"
                                                            : rowData.transaction_type === "inventory_transfer" || rowData.transaction_type === "opening_stock" || rowData.transaction_type === 'inventory_adjustment'
                                                                ? "Warehouse"
                                                                : rowData.asset_name ? "Asset"
                                                                    : rowData.employee_name ? "Employee"
                                                                        : "Workstation"} :
                                                    </b>
                                                </small>
                                                {rowData.transaction_type === "purchase" || rowData.transaction_type === 'purchase_return'
                                                    ? rowData.vendor_name ?? "-"
                                                    : rowData.transaction_type === "inventory_transfer" || rowData.transaction_type === "opening_stock" || rowData.transaction_type === 'inventory_adjustment'
                                                        ? rowData.warehouse_name ?? "-"
                                                        : rowData.asset_name ? rowData.asset_name
                                                            : rowData.employee_name ? rowData.employee_name
                                                                : rowData.workstation_name}
                                                {rowData.transaction_type === "purchase_consumption" && rowData.vendor_name && (
                                                    <div className='mt-1'>
                                                        <small className='form-text'><b>Vendor : </b></small> {rowData.vendor_name}
                                                    </div>
                                                )}
                                            </td>
                                            <td className='text-center'>{rowData.status ?? "-"}</td>
                                            <td className='text-end'>{rowData.received && rowData.received !== 0 ? rowData.received : ""}</td>
                                            <td className='text-end'>{rowData.issued && rowData.issued !== 0 ? rowData.issued : ""}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr><td className="text-center" colSpan={8}>No Record Found</td></tr>
                                )}
                            </tbody>
                        )}
                    </table>
                </div>
                {this.state.listingData.length > 0 && this.state.listingMeta && (
                    <DisplayListPagination
                        meta={this.state.listingMeta}
                        onPageChange={(e) => this.loadListingOnPageClick(e.selected + 1)}
                    />
                )}
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        access_token: state.auth.access_token,
        all_periods_from_store: state.app && state.app.all_periods ? state.app.all_periods : [],
    };
};

export default connect(mapStateToProps, null, null, { forwardRef: true })(TransactionLedgerContent);